export const appRootPath = '/web-login'
export const oauthTokenEndpoint = '/oauth/token'
export const authorizeEndpoint = '/authorize'
export const authorizeInitializerEndpoint = '/init'
export const setClientKeyEndpoint = '/client-key'

export const headersContentTypeFormUrlEncoded = {'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'}
